import React from "react";
import styled from "styled-components";
import { Instagram } from "../../assets/icons";
import { Facebook } from "../../assets/icons";
import { Twitter } from "../../assets/icons";
import { LinkedIn } from "../../assets/icons";
import { PlayStore } from "../../assets/images";
import { AppStore } from "../../assets/images";
import { Dropdown } from "../../assets/icons";
import { Text } from "../../TextConstants";
import { Colors } from "../../ColorConstants";

const MyCartFooter = ({}) => {
  return (
    <>
      <StyledFooterContainer>
        <ContactUsContainer>
          <ContactUsText>{Text.contactUs}</ContactUsText>
          <ContactIconsContainer>
            <ContactIcons src={Instagram} />
            <ContactIcons src={Facebook} />
            <ContactIcons src={Twitter} />
            <ContactIcons src={LinkedIn} />
          </ContactIconsContainer>
        </ContactUsContainer>
        <DownloadAppContainer>
          <DownloadText>{Text.downloadApp} </DownloadText>
          <DownloadSubText>{Text.discount}</DownloadSubText>
          <DownloadImagesContainer>
            <DownloadImage src={PlayStore} />
            <DownloadImage src={AppStore} />
          </DownloadImagesContainer>
        </DownloadAppContainer>
      </StyledFooterContainer>
      <PopularCategoryContainer>
        <PopularCategorySubdiv>
          <PopularCategoryText>{Text.popularCategory}</PopularCategoryText>
          <DropdownIcon src={Dropdown} />
        </PopularCategorySubdiv>
      </PopularCategoryContainer>
      <FooterText>{Text.footerText}</FooterText>
    </>
  );
};

const StyledFooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 2rem;
  background-color: ${Colors.arsenic};
  justify-content: space-around;
  padding-bottom: 1rem;
  @media only screen and (max-width: 640px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
const ContactUsContainer = styled.div`
  @media only screen and (max-width: 640px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
const ContactUsText = styled.span`
  color: ${Colors.lightWhiteSmoke};
  font-size: 1.5rem;
  font-weight: 700;
  @media only screen and (max-width: 1024px) {
    font-size: 1rem;
  }
`;

const ContactIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  margin-top: 1rem;
  @media only screen and (max-width: 640px) {
    justify-content: center;
    align-items: center;
  }
`;
const ContactIcons = styled.img`
  width: 2rem;
  height: 2rem;
`;
const DownloadAppContainer = styled(ContactUsContainer)`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 640px) {
    margin-top: 2rem;
  }
`;
const DownloadText = styled.span`
  color: ${Colors.white};
  font-size: 1.5rem;
  font-weight: 700;
  @media only screen and (max-width: 1024px) {
    font-size: 1rem;
  }
`;
const DownloadSubText = styled(DownloadText)`
  font-size: 1rem;
  font-weight: 300;
  @media only screen and (max-width: 1024px) {
    font-size: 0.8rem;
  }
`;
const DownloadImagesContainer = styled(ContactIconsContainer)`
  margin-top: 0.5rem;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
`;
const DownloadImage = styled.img`
  width: 10rem;
  height: 3rem;
`;
const PopularCategoryContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: ${Colors.arsenic};
`;
const PopularCategorySubdiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem 1rem 3rem;
  margin-top: 3rem;
  border-top: 1px solid ${Colors.rainbowGrey};
  border-bottom: 1px solid ${Colors.rainbowGrey};
  min-width: 65%;
  background-color: ${Colors.arsenic};
  @media only screen and (max-width: 640px) {
    padding: 1rem;
  }
`;
const PopularCategoryText = styled.span`
  color: ${Colors.lightWhiteSmoke};
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 700;
`;
const DropdownIcon = styled.img`
  width: 1rem;
  height: 0.7rem;
`;
const FooterText = styled.div`
  background-color: ${Colors.arsenic};
  color: ${Colors.white};
  font-size: 1rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 2rem 0rem 1rem 0rem;
  @media only screen and (max-width: 1024px) {
    font-size: 1rem;
    padding: 2rem 2rem 1rem 2rem;
  }
`;

export default MyCartFooter;
